export var JobTemplateSortField;
(function (JobTemplateSortField) {
    JobTemplateSortField["JOB_TEMPLATE_SORT_FIELD_CREATED_AT"] = "createdAt";
    JobTemplateSortField["JOB_TEMPLATE_SORT_FIELD_NAME"] = "name";
})(JobTemplateSortField || (JobTemplateSortField = {}));
